<template>
  <div>
    <draggable v-model="_questionList"
               v-bind="dragOptions"
               @start="onDragStart"
               @end="onDragEnd"
    >
      <component
        v-for="(question, i) in questionList"
        :is="question.questionType === 'CHOICE' ? 'TestbankQuestionChoice' : 'TestbankQuestionSubjective'"
        :key="i"
        :type="type"
        :index="i"
        :question="question"
        :testbankObj="testbankObj"
        @deleteQuestion="onDeleteQuestion"
      />
    </draggable>
    <div v-if="isCreate || isCopy" class="pb-10 flex gap-x-2">
      <GrmBtn class="flex-1" @click="onAddQuestion('CHOICE')">{{ $t("testBank.add.choice") }}</GrmBtn>
      <GrmBtn class="flex-1" @click="onAddQuestion('SUBJECTIVE')">{{ $t("testBank.add.subjective") }}</GrmBtn>
    </div>
  </div>
</template>

<script>
import {mapState, mapGetters} from "vuex";

import GrmBtn from "@/components/Common/button/GrmBtn.vue";
import TestbankQuestionChoice from "@/components/Room/Testbank/Question/TestbankQuestionChoice.vue";
import TestbankQuestionSubjective from "@/components/Room/Testbank/Question/TestbankQuestionSubjective.vue";

export default {
  name: 'TestbankQuestionList',
  components: {
    GrmBtn,
    TestbankQuestionChoice,
    TestbankQuestionSubjective,
  },
  props: {
    type: { type: String, default: 'view' },
    testbankObj: { type: Object, default: () => ({}) },
    questionList: { type: Array, default: () => ([]) },
  },
  computed: {
    ...mapState('testbank', [
      'view',
      'testbankExam',
    ]),
    ...mapGetters('testbank', [
      'isCreate',
      'isCopy',
    ]),

    dragOptions() {
      return {
        animation: 200,
        group: 'questionItem',
        ghostClass: 'opacity-20',
        handle: '.handleQuestion',
      };
    },
    _questionList: {
      get() {
        return this.questionList;
      },
      set(list) {
        list.map((item, i) => item.questionOrder = i);
        this.$emit('updateQuestionList', list);
      }
    },
  },
  methods: {
    onDragStart() {
      this.$root.$el.classList.add('cursor-grabbing');
    },
    onDragEnd() {
      this.$root.$el.classList.remove('cursor-grabbing');
    },
    onAddQuestion(questionType) {
      this.questionList.push({
        questionTitle: '',
        questionType: questionType,
        correctAnswerCnt: questionType === 'CHOICE' ? 0 : 1,
        questionScore: 1,
        questionOrder: this.questionList.length,
        answerList: (() => {
          if (questionType === 'CHOICE') {
            return [
              { answerTitle: '', correct: false, answerOrder: 0 },
              { answerTitle: '', correct: false, answerOrder: 1 },
            ]
          } else {
            return [
              { answerText: '', correct: true, answerOrder: 0 },
            ]
          }
        })(),
      });

      this.$nextTick(() => {
        const roomExamContentComponentWrapper = document.querySelector('#roomExamContentComponentWrapper');
        roomExamContentComponentWrapper.scrollTop = roomExamContentComponentWrapper.scrollHeight;
      });
    },
    onDeleteQuestion(question) {
      if (this.questionList.length === 1) {
        return;
      }

      this.questionList.splice(this.questionList.indexOf(question), 1);
    },
  }
}
</script>